export default __webpack_public_path__ + "static/media/jelastic.af04a8e2.svg";